import React, { useCallback, useState } from 'react';
import { Box, ChevronDownIcon, ChevronUpIcon, Grid, RawButton, Text } from '@common-fe/common-fe';

interface Props {
  title: string;
  children: React.ReactNode;
  isLargeMode?: boolean;
  disabled?: boolean;
}
const ReportSection: React.FC<Props> = ({ title, children, isLargeMode, disabled }) => {
  const [isVisible, setVisible] = useState(true);
  const handleToggleVisible = useCallback(() => {
    setVisible(!isVisible);
  }, [isVisible]);
  return (
    <Box direction="column">
      <RawButton onClick={disabled ? undefined : handleToggleVisible}>
        <Box direction="row" align="center">
          {isVisible && !disabled ? (
            <ChevronUpIcon size="24px" color="iconPrimary" />
          ) : (
            <ChevronDownIcon size="24px" color="iconPrimary" />
          )}
          <Text margin={{ left: 'spacing2' }} weight={700} size="xxlarge">
            {title}
          </Text>
        </Box>
      </RawButton>
      {isVisible && !disabled && (
        <Box pad="l" direction="row" background="module" round="moduleRound" margin={{ top: 'spacing12' }}>
          <Grid columns={isLargeMode ? '1/2' : '1/3'} gap="spacing24" fill>
            {children}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default ReportSection;
